<template>
  <header v-if="headerShow">
    <div class="all-header">
      <iframe class="iframepage" src="" width="" height=""></iframe>
      <div class="header-logo">
        <h1>
          <a to="/" @click="tolink('/')" title="逛球街"></a>
        </h1>
      </div>
      <nav>
        <ul>
          <li>
            <a @click="tolink('/')" class="haed_shouye">首页</a>
          </li>
          <li>
            <a @click="tolink('/zuqiu')" class="haed_zuqiu">足球比分</a>
          </li>
          <li>
            <a @click="tolink('/lanqiu')" class="haed_lanqiu">篮球比分</a>
          </li>
          <li>
            <a @click="tolink('/gaming/lol')" class="haed_gaming">电竞比分</a>
          </li>
          <li>
            <a @click="tolink('/zonghe')" class="haed_zonghe">综合&ensp;</a>
            <div class="slidedown">
              <div class="d-main">
                <ul>
                  <li v-for="(item, index) in nav" :key="index" :data-key="item.type" v-show="index > 0">
                    <span @click="tolink('/zonghe/' + item.type)">{{
    item.name
  }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li>
            <a @click="tolink('/news')" class="haed_news">体育资讯</a>
          </li>
          <li>
            <a @click="tolink('/tuijian')" class="haed_tuijian">每日精推</a>
          </li>
          <li>
            <a @click="tolink('/shuju')" rel="nofollow" class="haed_shuju">数据</a>
          </li>
        </ul>
      </nav>
      <div class="login_title">
        <!-- <div class="app">
          <i class="iconfont2">&#xe63a;</i>
          <a @click="tolink('/app')" class="haed_app">APP下载</a>
        </div> -->
        <div class="app" style="margin-left:20px" v-if="getCookie('type') == 2 || getCookie('type') == 9">
          <i class="iconfont2">&#xe635;</i>
          <a @click="editmsg(4)" class="haed_app">开始直播</a>
        </div>
        <div class="app" style="margin-left:20px" v-else>
          <i class="iconfont2">&#xe635;</i>
          <a @click="editmsg(2)" class="haed_app">申请开播</a>
        </div>
        <ul class="before_login">
          <i class="iconfont">&#xe894;</i>
          <li class="login_btn" @click="pwloginFn()">登录</li>
          <li class="zhuce1_btn" @click="zhuceloginFn()">注册</li>
        </ul>
        <ul class="after_login">
          <li>
            <img src="#" />
            <div class="anchor_tab" v-show="getCookie('type') == 2">
              <img src="//static.fly2a.com/static/image/anchor_tab.png" />
            </div>
          </li>
          <div class="editbox">
            <div>
              <div class="editimg">
                <img src="#" alt="" width="61px" height="61px" @click="editmsg(1)" />
              </div>
              <div class="editname">
                <div class="user_id" @click="editmsg(1)">
                  <span></span>&ensp;<i class="iconfont2">&#xe639;</i>
                </div>
                <div class="user_enounce" @click="editmsg(1)">
                  点击编辑个性签名
                </div>
              </div>
              <div class="editexit" @click="exitLogin()">退出</div>
            </div>
            <div class="usercenter">
              <div @click="editmsg(1)">
                <i class="iconfont2">&#xe636;</i><br />
                <span>个人资料</span>
              </div>
              <div @click="editmsg(2)" v-show="getCookie('type') != 2 && getCookie('type') != 9">
                <i class="iconfont2">&#xe635;</i><br />
                <span>申请开播</span>
              </div>
              <div @click="editmsg(4)" v-show="getCookie('type') == 2 || getCookie('type') == 9">
                <i class="iconfont2">&#xe63c;</i><br />
                <span>开始直播</span>
              </div>
              <div @click="editmsg(3)" v-show="getCookie('type') > 1">
                <i class="iconfont2">&#xe638;</i><br />
                <span>开播教程</span>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
    <!-- 登陆弹框 -->
    <div class="loading">
      <div class="loading_content">
        <form>
          <div class="loading_logo">
            <img src="https://cdnlq.yyclq.com/files/team/gqj_logo.png" />
          </div>
          <!-- 登陆 -->
          <div class="loading_content1">
            <div class="loading_title">
              <p class="zhanghao loading_active" @click="pwloginFn()">
                账号登录
              </p>
              <p class="dongtai" @click="yzmloginFn()">动态登录</p>
            </div>
            <!--账号登录 -->
            <div class="zhanghao_content">
              <input placeholder="请输入手机号码" class="account" />
              <input placeholder="请输入登录密码" type="password" class="password" @keydown="keydownFn($event, 'password')" />
            </div>
            <!--动态登录 -->
            <div class="dongtai_content">
              <input placeholder="请输入手机号码" class="tel1" />
              <div v-show="imgcodeShow">
                <input placeholder="请输入右侧验证码" class="authcode authcode1" />
                <img src="" alt="" class="authimg authimg1" width="112px" height="36px" @click="getimgcode()"
                  title="点击切换验证码" />
              </div>
              <div style="position: relative">
                <input placeholder="请输入短信验证码" class="code1" @keydown="keydownFn($event, 1)" />
                <span class="get_message1" isable="able" :disabled="isDisabled" @click="sendCode(1)">获取验证码</span>
              </div>
            </div>
            <div class="forget">
              <p @click="findpwloginFn()">忘记密码</p>
            </div>
            <input type="button" value="登录" class="dongtai_btn zhangHao" @click="zhangHao()" />
            <input type="button" value="登录" class="dongtai_btn dongTai" @click="dongTai()" />
          </div>
          <!-- 注册账号 -->
          <div class="loading_content2">
            <div class="loading_title">
              <p class="zhanghao loading_active" rel="nofollow">注册账号</p>
              <p class="dongtai" @click="pwloginFn()">
                已有账号？<span class="goToLoading">马上登陆</span>
              </p>
            </div>
            <div class="zhuce_content">
              <div>
                <i class="iconfont username">&#xe67b;</i>
                <input placeholder="欢迎来到逛球街，请设置用户名" maxlength="15" class="preicon ipt_username" />
              </div>
              <div>
                <i class="iconfont mobile">&#xe60d;</i>
                <input placeholder="请输入手机号码" class="preicon tel2" />
              </div>
              <div>
                <i class="iconfont password">&#xe603;</i>
                <input placeholder="请输入登录密码" type="password" class="preicon mine_password" />
              </div>
              <div v-show="imgcodeShow">
                <input placeholder="请输入右侧验证码" class="authcode authcode2" />
                <img src="" alt="" class="authimg authimg2" width="112px" height="36px" @click="getimgcode()"
                  title="点击切换验证码" />
              </div>
              <div class="code">
                <input placeholder="请输入短信验证码" class="code2" @keydown="keydownFn($event, 2)" />
                <span class="get_message2" isable="able" :disabled="isDisabled" @click="sendCode(2)">获取验证码</span>
              </div>
            </div>
            <div class="xieyi">
              <i class="xieyi_cicle" @click="cicletag()"></i>
              <i class="iconfont i_active" @click="cicletag(1)">&#xe6a5;</i>
              <span rel="nofollow">同意</span>
              <a href="/protocol" target="_blank" rel="nofollow">《用户注册协议》</a>
            </div>
            <input type="button" value="注册" class="dongtai_btn" @click="zhuCe()" />
          </div>
          <!-- 找回密码 -->
          <div class="loading_content3">
            <div class="loading_title">
              <p class="zhanghao loading_active find_password">重置密码</p>
              <p class="dongtai" @click="pwloginFn()">
                <span class="goToLoading1">返回登陆</span>
              </p>
            </div>
            <div class="xiugai_content">
              <div>
                <input placeholder="请输入手机号码" class="tel3" />
              </div>
              <div>
                <input placeholder="请输入新的登录密码" type="password" class="new_password1" />
              </div>
              <div>
                <input placeholder="请确认新的登录密码" type="password" class="new_password2" />
              </div>
              <div v-show="imgcodeShow">
                <input placeholder="请输入右侧验证码" class="authcode authcode3" />
                <img src="" alt="" class="authimg authimg3" width="112px" height="36px" @click="getimgcode()"
                  title="点击切换验证码" />
              </div>
              <div>
                <input placeholder="请输入短信验证码" class="code3" @keydown="keydownFn($event, 3)" />
                <span class="get_message3" isable="able" :disabled="isDisabled" @click="sendCode(3)">获取验证码</span>
              </div>
            </div>
            <input type="button" value="确认" class="dongtai_btn" @click="forgerPassword()" />
          </div>
          <p class="zhuce" @click="zhuceloginFn()">新用户注册</p>
          <!--<div class="wx_login">
						<div class="">
							<div class="line"></div>
							<div class="wx_title">使用其他登录方式登录</div>
						</div>
						<img src="https://static.fly2a.com/static/image/wx_logo.png" alt="" @click="wxlogin()"/>
					</div>-->
          <div class="other_way" style="display: none">
            <p rel="nofollow">使用其他登录方式</p>
            <div class="ways" style="position: relative">
              <a href="/sys_login/sina" class=""><i class="iconfont">&#xe635;</i></a>
              <a href="/sys_login/qq" class=""><i class="iconfont">&#xe6e1;</i></a>
              <a href="/sys_login/weixin" class=""><i class="iconfont">&#xe637;</i></a>
            </div>
          </div>
        </form>
        <i class="iconfont close_login" @click="closeloginFn()">&#xe639;</i>
      </div>
    </div>

    <!-- 绑定手机 -->
    <div class="binding" v-show="binding">
      <div class="binding_content">
        <div class="title">绑定手机</div>
        <div class="subheading">为了确保您的账户安全，请立即绑定手机号</div>
        <input placeholder="请输入手机号码" class="tel4" />
        <div v-show="imgcodeShow">
          <input placeholder="请输入右侧验证码" class="authcode authcode4" />
          <img src="" alt="" class="authimg authimg4" width="112px" height="36px" @click="getimgcode()"
            title="点击切换验证码" />
        </div>
        <div class="code">
          <input placeholder="请输入短信验证码" class="code4" @keydown="keydownFn($event, 4)" />
          <span class="get_message4" isable="able" :disabled="isDisabled" @click="sendCode(4)">获取验证码</span>
        </div>
        <div class="bind_btn" @click="bindFn()">立即绑定</div>
        <i class="iconfont close_login" @click="binding = 0">&#xe639;</i>
      </div>
    </div>
    <!--个人中心-->
    <!--<myExit></myExit>-->
    <bf-exit v-bind:exitshow="exitshow" v-bind:qiniutoken="qiniutoken" v-on:exituser="exituser"
      v-on:usermsg="usermsgFn"></bf-exit>
  </header>
</template>

<script>
import BfExit from "./Exit";
import axios from "axios";
import { mapState,mapMutations } from 'vuex';
axios.defaults.withCredentials = true;
export default {
  components: {
    BfExit,
  },
  data() {
    return {
      isDisabled: false,
      isActive: true,
      myExit_H: "900px",
      headerShow: 0,
      nav: [
        {
          type: 99,
          name: "综合",
          color: "#5fcda7",
        },
        {
          type: 4,
          name: "网球",
          color: "#F1A765",
        },
        {
          type: 5,
          name: "排球",
          color: "#FAB631",
        },
        {
          type: 6,
          name: "台球",
          color: "#3763C7",
        },
        {
          type: 7,
          name: "羽毛球",
          color: "#E85759",
        },
        {
          type: 8,
          name: "电竞",
          color: "#4B8FD4",
        },
        {
          type: 3,
          name: "其他",
          color: "#5fcda7",
        },
      ],
      wx_login_t: "",
      binding: 0,
      imgcodeShow: 0,
      exitshow: 0,
      qiniutoken: "",
    };
  },
  created() {
    this.myExit_H = $(window).height() - 60 + "px";
    if (location.href.indexOf("exit") == -1) {
      this.headerShow = 1;
    }
    this.getType();
  },
  //		components: {
  //			MyExit
  //		},
  mounted: function () {
    //钩子
    if (location.href.indexOf("wx_login_t") != -1) {
      this.wx_login_t = this.getObj().wx_login_t;
      if (this.wx_login_t) {
        if (this.wx_login_t == 302) {
          this.initialize();
          this.getimgcode();
          this.binding = 1;
        } else {
          this.setCookie("token", this.wx_login_t);
        }
      }
    }
    if (location.href.indexOf("exit") == -1) {
      var isMsie =
        navigator.userAgent.toLowerCase().indexOf("msie") != -1 ? true : false;
      if (isMsie) {
        alert("为了更好的浏览效果，建议使用谷歌浏览器或其它浏览器的极速模式！");
      }
      this.loginFun();
    }
  },
  computed: {
    ...mapState(['ballType']),
  },
  methods: {
    ...mapMutations(['SET_TYPES']),
    exituser() {
      this.exitshow = 0;
      $("header + div>div").show();
      if ($("#iframe2").length > 0) {
        if (sessionStorage.getItem("iframe2")) {
          $("#iframe2").attr("src", sessionStorage.getItem("iframe2"));
        }
      }
      this.$emit("exitshow", 0, true);
    },
    usermsgFn(data) {
      var userName = data.user_name;
      var enounce = data.enounce;
      var face = data.face;
      var type = data.type;
      if (userName.length > 8) {
        userName = userName.slice(0, 8) + "...";
      }
      if (enounce.length > 16) {
        enounce = enounce.slice(0, 16) + "...";
      }
      $(".user_enounce").text(enounce ? enounce : "点击编辑个性签名");
      $(".user_id span").text(userName);
      if (face != "") {
        $(".after_login li>img, .editimg img").attr("src", face);
      }
      if (type == 2) {
        $(".login_title .after_login li .anchor_tab").css("display", "block");
        //		$("#showAddUrlBtn").css("display","inline");
      } else {
        $(".login_title .after_login li .anchor_tab").css("display", "none");
        //		$("#showAddUrlBtn").css("display","none");
      }
      if (type > 1) {
        $(".after_login .usercenter>div:nth-child(4)").css(
          "display",
          "inline-block"
        );
      } else {
        $(".after_login .usercenter>div:nth-child(4)").css("display", "none");
      }
      if (type == 2 || type == 9) {
        $(".after_login .usercenter>div:nth-child(3)").css(
          "display",
          "inline-block"
        );
        $(".after_login .usercenter>div:nth-child(2)").css("display", "none");
      } else {
        $(".after_login .usercenter>div:nth-child(3)").css("display", "none");
        $(".after_login .usercenter>div:nth-child(2)").css(
          "display",
          "inline-block"
        );
      }
    },
    wxlogin() {
      var jump_url = encodeURIComponent(
        window.location.pathname + window.location.search
      );
      window.location.href =
        COMMOND.BASE_URL + "wx_pc_login?jump_url=" + jump_url;
    },
    getObj() {
      var oDate = window.location.search.replace("?", "").split("&");
      var obj = {};
      for (var i = 0; i < oDate.length; i++) {
        obj[oDate[i].split("=")[0]] = oDate[i].split("=")[1];
      }
      return obj;
    },
    getType() {
      axios.get(COMMOND.NEW_BASE_URL + "get_type").then((res) => {
        var data = res.data;
        if (data.code == 200) { 
         this.nav = data.data;
         let type_nav = {}
         for (var i = 0; i < data.data.length; i++) {
              type_nav[data.data[i].type] = {
                name: data.data[i].name,
                color: data.data[i].color,
                logo: data.data[i].type_logo,
            };
          }
          this.SET_TYPES(type_nav);
        }
      });
    },
    //获取验证码图片
    getimgcode() {
      if (!this.imgcodeShow) {
        axios.get(COMMOND.NEW_BASE_URL + "get_img_code_switch").then((res) => {
          this.imgcodeShow = res.data;
          if (this.imgcodeShow) {
            $(".authimg").attr(
              "src",
              COMMOND.NEW_BASE_URL + "get_img_code?" + Math.random() * 10000
            );
          }
        });
      } else {
        $(".authimg").attr(
          "src",
          COMMOND.NEW_BASE_URL + "get_img_code?" + Math.random() * 10000
        );
      }
    },
    tolink(url) {
      if (url == "/" && location.hostname == "live.qiu006.com") {
        location.href = "https://qiu006.com";
        return;
      }
      if (
        url.indexOf("zonghe") != -1 &&
        window.location.href.indexOf("zonghe") != -1
      ) {
        window.location.href = url;
      } else {
        window.open(url);
      }
    },
    requestPost(data) {
      var oJson = [];
      for (let key in data.data) {
        oJson.push(key + "=" + data.data[key]);
      }
      oJson = oJson.join("&");
      var url = COMMOND.NEW_BASE_URL + data.url;
      if (data.url == "login_out") {
        axios
          .post(
            url,
            {},
            {
              headers: data.data,
            }
          )
          .then((res) => {
            layer.open({
              content: "已退出登录",
            });
          });
      } else {
        axios.post(url, oJson).then((res) => {
          if (data.fn) {
            data.fn(res.data);
          }
        });
      }
    },
    //多页面设置cookie值
    setCookie(name, value) {
      document.cookie = name + "=" + value + ";path=/";
    },
    //获取cookie值
    getCookie(name) {
      var arr = document.cookie.split("; ");
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == name) {
          return arr2[1];
        }
      }
      return "";
    },
    //密码登录框
    pwloginFn() {
      this.initialize();
      $(".layui-layer-tips").remove();
      $(".loading_content1 .dongtai_btn.zhangHao").show();
      $(".loading_content1 .dongtai_btn.dongTai").hide();
      $(".loading").show();
      $(".loading_content1").show();
      $(".loading_content1 .loading_active").removeClass("loading_active");
      $(".loading_content1 .loading_title .zhanghao").addClass(
        "loading_active"
      );
      $(".loading_content1 .zhanghao_content").css("display", "block");
      $(".loading_content1 .forget").css("display", "block");
      $(".loading_content1 .dongtai_content").css("display", "none");
      $(".zhuce").show();
      $(".wx_login").show();
      $(".loading_content2").hide();
      $(".loading_content3").hide();
    },
    zhangHao() {
      var that = this;
      var account = $(".account").val();
      var password = $(".password").val();
      if (account == "") {
        layer.open({
          content: "请输入账号",
        });
        return false;
      }
      if (password == "") {
        layer.open({
          content: "请输入密码",
        });
        return false;
      }
      if (account != "" && password != "") {
        this.requestPost({
          url: "login",
          data: {
            username: account,
            password: password,
          },
          fn: loginbypwd,
        });

        function loginbypwd(data) {
          if (data.code == 200) {
            that.handleSuccessLogin(data);
          } else {
            layer.open({
              content: data.msg,
            });
          }
        }
      }
    },
    //验证码登录框
    yzmloginFn() {
      this.initialize();
      this.getimgcode();
      $(".loading_content1 .dongtai_btn.zhangHao").hide();
      $(".loading_content1 .dongtai_btn.dongTai").show();
      $(".loading").show();
      $(".loading_content1").show();
      $(".loading_content1 .loading_active").removeClass("loading_active");
      $(".loading_content1 .loading_title .dongtai").addClass("loading_active");
      $(".loading_content1 .dongtai_content").css("display", "block");
      $(".loading_content1 .zhanghao_content").css("display", "none");
      $(".loading_content1 .forget").css("display", "none");
      $(".zhuce").show();
      $(".wx_login").show();
      $(".loading_content2").hide();
      $(".loading_content3").hide();
    },
    dongTai() {
      var that = this;
      var tel = $(".tel1").val();
      var code = $(".code1").val();
      if (tel == "") {
        layer.open({
          content: "请输入手机号",
        });
        return false;
      }
      if (code != "") {
        this.requestPost({
          url: "sms_verify_code",
          data: {
            mobile: tel,
            verify_code: code,
          },
          fn: loginbycode,
        });

        function loginbycode(data) {
          if (data.code == 200) {
            that.handleSuccessLogin(data);
          } else {
            layer.open({
              content: data.msg,
            });
          }
        }
      } else {
        layer.open({
          content: "请输入验证码",
        });
      }
    },
    //忘记密码登录框
    findpwloginFn() {
      this.initialize();
      this.getimgcode();
      $(".loading").show();
      $(".loading_content3").show();
      $(".zhuce").show();
      $(".wx_login").hide();
      $(".loading_content1").hide();
      $(".loading_content2").hide();
    },
    forgerPassword() {
      var that = this;
      var tel = $(".tel3").val();
      var code = $(".code3").val();
      var password1 = $(".new_password1").val();
      var password2 = $(".new_password2").val();
      if (tel == "") {
        layer.open({
          content: "请输入手机号码",
        });
        return false;
      }
      if (password1 == "") {
        layer.open({
          content: "请输入新密码",
        });
        return false;
      }
      if (password2 == "") {
        layer.open({
          content: "请输入确认密码",
        });
        return false;
      }
      if (password1 != password2) {
        layer.open({
          content: "两次输入的密码要相同哟~",
        });
        return false;
      }
      if (code == "") {
        layer.open({
          content: "请输入验证码~",
        });
        return false;
      }
      if (code != "" && password1 == password2 && tel != "") {
        this.requestPost({
          url: "set_pw",
          data: {
            mobile: tel,
            code: code,
            password: password2,
          },
          fn: loginbycode,
        });

        function loginbycode(data) {
          if (data.code == 200) {
            that.handleSuccessLogin(data);
          } else {
            layer.open({
              content: data.msg,
            });
          }
        }
      }
    },
    bindFn() {
      var that = this;
      var tel = $(".tel4").val();
      var code = $(".code4").val();
      if (tel == "") {
        layer.open({
          content: "请输入手机号码",
        });
        return false;
      }
      if (code == "") {
        layer.open({
          content: "请输入验证码~",
        });
        return false;
      }
      if (code != "" && tel != "") {
        axios
          .post(
            COMMOND.BASE_URL + "pc_bind_wx_verify",
            {
              mobile: tel,
              verify_code: code,
            },
            {
              responseType: "json",
              withCredentials: true,
            }
          )
          .then((res) => {
            var data = res.data;
            if (data.code == 200) {
              that.handleSuccessLogin(data);
            } else {
              layer.open({
                content: data.msg,
              });
            }
          });
        //					this.requestPost({
        //						url: "pc_bind_wx_verify",
        //						data: {
        //							'mobile': tel,
        //							'verify_code': code
        //						},
        //						fn: bindbycode
        //					})
        //
        //					function bindbycode(data) {
        //						if(data.code == 200) {
        //							that.handleSuccessLogin(data);
        //						} else {
        //							layer.open({
        //								content: data.msg,
        //							});
        //						}
        //					}
      }
    },
    //注册登录框
    zhuceloginFn() {
      this.initialize('reg');
      $(".layui-layer-tips").remove();
      this.getimgcode();
      $(".loading").show();
      $(".loading_content1").hide();
      $(".loading_content3").hide();
      $(".zhuce").hide();
      $(".wx_login").hide();
      $(".loading_content2").show();
      $("input[name='loading_btn']").attr("class", "zhuce_btn");
    },
    zhuCe() {
      var that = this;
      var active = $(".i_active").css("display");
      var username = $(".ipt_username").val();
      var tel = $(".tel2").val();
      var code = $(".code2").val();
      var password = $(".mine_password").val();
      if (!username.trim()) {
        layer.open({
          content: "请输入用户名",
        });
        return false;
      }
      if (code == "") {
        layer.open({
          content: "请输入验证码",
        });
        return false;
      }
      if (password == "") {
        layer.open({
          content: "请输入密码",
        });
        return false;
      }
      if (tel == "") {
        layer.open({
          content: "请输入手机号",
        });
        return false;
      }
      if (active == "none") {
        layer.open({
          content: "请勾选用户注册协议",
        });
        return false;
      }
      if (password.length < 6) {
        layer.open({
          content: "密码必须6位数及以上",
        });
        return false;
      }
      if (username != "" && code != "" && password != "" && tel != "" && active != "none") {
        this.requestPost({
          url: "register",
          data: {
            username: username.trim(),
            required_username: 1,
            mobile: tel,
            code: code,
            password: password,
          },
          fn: registbycode,
        });

        function registbycode(data) {
          if (data.code == 200) {
            that.handleSuccessLogin(data);
          } else {
            layer.open({
              content: data.msg,
            });
          }
        }
      }
    },
    keydownFn(e, type) {
      if (e.keyCode === 13 && !e.ctrlKey) {
        e.preventDefault();
        if (type == "password") {
          this.zhangHao();
        } else if (type == 1) {
          this.dongTai();
        } else if (type == 2) {
          this.zhuCe();
        } else if (type == 3) {
          this.forgerPassword();
        } else if (type == 4) {
          this.bindFn();
        }
      }
    },
    //关闭登录框
    closeloginFn() {
      $(".loading").hide();
    },
    cicletag(type) {
      if (type) {
        $(".xieyi_cicle").show();
        $(".i_active").hide();
      } else {
        $(".i_active").show();
        $(".xieyi_cicle").hide();
      }
    },
    //点击发送验证码
    sendCode(type) {
      var that = this;
      var regmobile = /^1[3|4|5|7|6|8|9][0-9]\d{4,8}$/; //定义手机号正则表达式
      var img_code = $(".authcode" + type).val();
      var tel = $(".tel" + type).val();
      if ((tel && img_code) || (!this.imgcodeShow && tel)) {
        if (!regmobile.test(tel)) {
          //判断手机号
          // alert("账号格式有误！请重新输入");
          layer.open({
            content: "账号格式有误！请重新输入",
          });
          $(".tel" + type).val("");
          $(".tel" + type).focus();
        } else {
          if (this.isDisabled) return;
          this.isDisabled = true;
          this.requestPost({
            url: "sms_send_code",
            data: {
              mobile: tel,
              img_code: img_code,
            },
            fn: sendsms,
          });

          function sendsms(data) {
            if (data.code == 200) {
              that.jishi(".get_message" + type, 60);
              layer.open({
                content: "验证码已发送",
              });
              that.isDisabled = false;
            } else {
              layer.open({
                content: data.msg,
              });
              that.getimgcode();
              that.isDisabled = false;
            }
          }
        }
      } else {
        if (!tel) {
          layer.open({
            content: "请输入手机号码~",
          });
        } else if (!img_code) {
          layer.open({
            content: "请输入图形验证码~",
          });
        }
      }
    },
    //初始化输入框
    initialize(type) {
      $(".loading input").val("");
      $(
        ".loading .get_message1, .loading .get_message2, .loading .get_message3, .get_message4"
      ).text("获取验证码");
      $(
        ".loading .get_message1, .loading .get_message2, .loading .get_message3, .get_message4"
      ).attr("isable", "able");
      $(
        ".loading .get_message1, .loading .get_message2, .loading .get_message3, .get_message4"
      ).removeClass("noevent");
      $("input[type='button']").val(type == 'reg' ? '注册' : '登录');
    },
    //倒计时
    jishi(dom, time1) {
      var isable = $(dom).attr("isable");
      // console.log(isable)
      if (isable == "able") {
        var time = time1;
        if (time) {
          $(dom).attr("isable", "disabled");
          $(dom).addClass("noevent");
          $(dom).html("重新发送" + time + "s");
          var _res = setInterval(function () {
            var isable1 = $(dom).attr("isable");
            if (isable1 != "able") {
              time -= 1;
              if (time) {
                $(dom).html("重新发送" + time + "s");
              } else {
                time = 0;
              }
              if (time <= 0) {
                $(dom).attr("isable", "able");
                $(dom).removeClass("noevent");
                $(dom).html("重新获取");
                clearInterval(_res);
              }
            } else {
              $(dom).removeClass("noevent");
              clearInterval(_res);
            }
          }, 1000);
        }
      }
    },
    //  处理成功登录
    handleSuccessLogin(data) {
      //				this.suijiImg()
      data.data.enounce =
        data.data.enounce == null || data.data.enounce == "null"
          ? ""
          : data.data.enounce;
      $(".loading").hide();
      $(".before_login").hide();
      $(".after_login").show();
      this.setCookie("telphone_number", data.data.mobile);
      this.setCookie("userName", encodeURI(data.data.username));
      this.setCookie("member_id", data.data.member_id);
      this.setCookie("keys", data.data.keys);
      this.setCookie("type", data.data.type);
      this.setCookie("enounce", encodeURI(data.data.enounce));
      //				if(data.data.face != "") {
      this.setCookie("face", data.data.face);
      //				} else {
      //					this.setCookie("face", window.face_img);
      //				}
      this.setCookie("token", data.data.token);
      this.setCookie("netease_im_token", data.data.netease_im_token);
      if (data.data.username.length > 8) {
        data.data.username = data.data.username.slice(0, 8) + "...";
      }
      if (data.data.enounce.length > 16) {
        data.data.enounce = data.data.enounce.slice(0, 16) + "...";
      }
      $(".user_id span").text(data.data.username);
      $(".user_enounce").text(
        data.data.enounce &&
          data.data.enounce != null &&
          data.data.enounce != "null"
          ? data.data.enounce
          : "点击编辑个性签名"
      );
      if (data.data.face != "") {
        $(".after_login li>img, .editimg img").attr("src", data.data.face);
      } else {
        $(".after_login li>img, .editimg img").attr("src", window.face_img);
      }
      this.initialize();
      window.location.reload();
    },
    //退出-------------------------------------------------------
    exitLogin() {
      var token = this.getCookie("token");
      $(".before_login").show();
      $(".after_login").hide();
      $(".loading").hide();
      $(".user_id span").text("");
      $(".user_enounce").text("点击编辑个性签名");
      $(".after_login li>img, .editimg img").attr("src", "");
      this.clearCookie();
      if (token != "") {
        //					$("#app>div>div").show();
        //					$(".user").hide();
        //					if($("#iframe2").length>0){
        //						if(sessionStorage.getItem("iframe2")){
        //							$("#iframe2").attr("src", sessionStorage.getItem("iframe2"));
        //						}
        //					}
        this.requestPost({
          url: "login_out",
          data: {
            Authorization: token,
          },
        });
      }
    },
    //请空cookie
    clearCookie() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--;) {
          document.cookie =
            keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString();
        }
      }

      window.location.reload();
    },
    editmsg(type) {
      if (!this.getCookie("token")) {
        $(".before_login").show();
        $(".after_login").hide();
        this.pwloginFn();
        return;
      }
      if (type == 4) {
        location.href = "/anchor/";
        return;
      }
      $(".layui-layer-tips").remove();
      $("header + div>div").hide();
      this.exitshow = type;
      this.$emit("exitshow", type, true);
      if ($("#iframe2").length > 0) {
        if ($("#iframe2").attr("src")) {
          sessionStorage.setItem("iframe2", $("#iframe2").attr("src"));
          $("#iframe2").attr("src", "");
        }
      }
    },
    loginFun() {
      var that = this;

      function checklogin() {
        let json = {
          mobile: this.getCookie("telphone_number"),
          userName: decodeURI(this.getCookie("userName")),
          member_id: this.getCookie("member_id"),
          keys: this.getCookie("keys"),
          face: this.getCookie("face"),
          token: this.getCookie("token"),
          netease_im_token: this.getCookie("netease_im_token"),
        };
        var data = JSON.stringify(json);
        data = encodeURIComponent(data);
        if (window.location.href.indexOf("live") != -1) {
          $(".iframepage").attr("src", "//www.qiu006.com/zuqiu?data=" + data);
          setTimeout(function () {
            window.location.reload();
          }, 1500);
        } else {
          $(".iframepage").attr(
            "src",
            COMMOND.DOMAIN_NAME + "/zuqiu/live?data=" + data
          );
        }
      }

      //判断是否登录
      var token = this.getCookie("token");
      var member_id1 = this.getCookie("member_id");
      var userName1 = decodeURI(this.getCookie("userName"));
      var enounce1 = decodeURI(this.getCookie("enounce"));
      var face = this.getCookie("face");
      if (token != "") {
        $(".before_login").hide();
        $(".after_login").show();
        $(".loading").hide();
        $(".before_login").hide();
        $(".after_login").show();
        $(".loading").hide();
        if (userName1.length > 8) {
          userName1 = userName1.slice(0, 8) + "...";
        }
        if (enounce1.length > 16) {
          enounce1 = enounce1.slice(0, 16) + "...";
        }
        $(".user_id span").text(userName1);
        $(".user_enounce").text(
          enounce1 && enounce1 != null && enounce1 != "null"
            ? enounce1
            : "点击编辑个性签名"
        );
        if (face != "") {
          $(".after_login li>img, .editimg img").attr("src", face);
        }
      }

      //回到顶部------------------------------------------------------------
      var windowHeight = $(window).height();
      $(window).scroll(function () {
        if ($(document).scrollTop() > windowHeight) {
          $(".goToTop").css({
            visibility: "visible",
          });
        } else {
          $(".goToTop").css({
            visibility: "hidden",
          });
        }
      });
      $(".goToTop").click(function () {
        $("html , body").animate(
          {
            scrollTop: 0,
          },
          "normal"
        );
      });

      $(".tQRcode")
        .stop()
        .mouseenter(function () {
          $(this).animate(
            {
              letterSpacing: "7px",
            },
            "fast"
          );
          $(this).animate(
            {
              letterSpacing: "0px",
            },
            "fast"
          );
        });

      $(".tQRcode").click(function () {
        $(this).css({
          display: "none",
          height: "0",
        });
        $(".QRcode img").animate(
          {
            height: "279px",
          },
          "normal"
        );
      });

      //随机头像
      function suijiImg() {
        var suiji_num = Math.random();
        if (suiji_num >= 0 && suiji_num < 0.125) {
          window.face_img =
            "//static.fly2a.com/static/image/member_head1.png";
        } else if (suiji_num >= 0.125 && suiji_num < 0.25) {
          window.face_img =
            "//static.fly2a.com/static/image/member_head2.png";
        } else if (suiji_num >= 0.25 && suiji_num < 0.375) {
          window.face_img =
            "//static.fly2a.com/static/image/member_head3.png";
        } else if (suiji_num >= 0.375 && suiji_num < 0.5) {
          window.face_img =
            "//static.fly2a.com/static/image/member_head4.png";
        } else if (suiji_num >= 0.5 && suiji_num < 0.625) {
          window.face_img =
            "//static.fly2a.com/static/image/member_head5.png";
        } else if (suiji_num >= 0.625 && suiji_num < 0.75) {
          window.face_img =
            "//static.fly2a.com/static/image/member_head6.png";
        } else if (suiji_num >= 0.75 && suiji_num < 0.875) {
          window.face_img =
            "//static.fly2a.com/static/image/member_head7.png";
        } else if (suiji_num >= 0.875 && suiji_num <= 1) {
          window.face_img =
            "//static.fly2a.com/static/image/member_head8.png";
        } else {
          window.face_img =
            "//static.fly2a.com/static/image/member_head1.png";
        }
      }

      //修改名字
      //				$(".after_login").on('click', ".name_bianji", function() {
      //					if(!that.getCookie("token")){
      //						$(".before_login").show();
      //						$(".after_login").hide();
      //						that.pwloginFn()
      //						return
      //					}
      //					if(location.href.indexOf("exit")==-1){
      //						$(".myExit").attr("src","/exit");
      //						$(".myExit").show();
      //						$("header").siblings().hide();
      //					}
      //					if($("#iframe2").length>0){
      //						if($("#iframe2").attr("src")){
      //							sessionStorage.setItem("iframe2",$("#iframe2").attr("src"));
      //							$("#iframe2").attr("src","");
      //						}
      //					}
      //				});
      $(".name_sure").click(function () {
        $(".name_edit").hide();
        var member_name = $(".name_content").val();
        if (member_name.length < 9) {
          $.ajax({
            url: COMMOND.NEW_BASE_URL + "update_user",
            headers: {
              Authorization: token,
            },
            data: {
              user_name: member_name,
            },
            type: "POST",
            dataType: "JSON",
            success: function (data) {
              if (data.code == 200) {
                layer.msg("昵称改为" + member_name);
                $(".user_id span").text(member_name);
                setCookie("userName", encodeURI(member_name));
              } else {
                layer.msg(data.msg);
              }
            },
          });
        } else {
          layer.msg("名字最多8个字符哟~");
        }
      });
      $(".name_cancle").click(function () {
        $(".name_edit").hide();
      });
    },
  },
};
</script>

<style scoped>
@import "../assets/css/denglu.css";
@import "../assets/css/header.css";
</style>
<style>
/*iconfont阿里字体图标*/

@font-face {
  font-family: "iconfont";
  /* project id 864845 */
  src: url("https://static.fly2a.com/gqj_tv/font/font_864845_y77u8c8poqe.eot");
  src: url("https://static.fly2a.com/gqj_tv/font/font_864845_y77u8c8poqe.eot?#iefix") format("embedded-opentype"),
    url("https://static.fly2a.com/gqj_tv/font/font_864845_y77u8c8poqe.woff2") format("woff2"),
    url("https://static.fly2a.com/gqj_tv/font/font_864845_y77u8c8poqe.woff") format("woff"),
    url("https://static.fly2a.com/gqj_tv/font/font_864845_y77u8c8poqe.ttf") format("truetype"),
    url("https://static.fly2a.com/gqj_tv/font/font_864845_y77u8c8poqe.svg#iconfont") format("svg");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: "iconfont2";
  /* project id 864845 */
  src: url("https://static.fly2a.com/gqj_live/font/iconfont.eot");
  src: url("https://static.fly2a.com/gqj_live/font/iconfont.eot?#iefix") format("embedded-opentype"),
    url("https://static.fly2a.com/gqj_live/font/iconfont.woff2") format("woff2"),
    url("https://static.fly2a.com/gqj_live/font/iconfont.woff") format("woff"),
    url("https://static.fly2a.com/gqj_live/font/iconfont.ttf") format("truetype"),
    url("https://static.fly2a.com/gqj_live/font/iconfont.svg#iconfont") format("svg");
}

.iconfont2 {
  font-family: "iconfont2" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: "review";
  /* project id 864845 */
  src: url("//static.fly2a.com/encryption/font/icomoon.eot");
  src: url("//static.fly2a.com/encryption/font/icomoon.eot?#iefix") format("embedded-opentype"),
    url("//static.fly2a.com/encryption/font/icomoon.woff") format("woff"),
    url("//static.fly2a.com/encryption/font/icomoon.ttf") format("truetype");
}

.review {
  display: inline-block;
  vertical-align: middle;
  margin-top: -2px;
  font-family: "review" !important;
  /*letter-spacing: 1.5px;*/
  /*font-size: 16px;*/
  /*font-style: normal;*/
  /*-webkit-font-smoothing: antialiased;
		-webkit-text-stroke-width: 0.2px;
		-moz-osx-font-smoothing: grayscale;*/
}
</style>
